import React from 'react';
import PropTypes from 'prop-types';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';

const DocumentView = ({
  title = localization.attachment,
  attachment = '#',
  showFullWidth = true
}) => {
  var fileType = ['xls','xlsx','csv','pdf'];
  return (
    <div className={showFullWidth ? "details-list full-width" : "details-list"}>
      <div className="upload-module view-document-module">
        <span className="file-name">
          <img src={Images?.fileIcon} alt="" />
          {title}
        </span>
        <span className="document-link" style={{"margin": "0rem 1rem"}}>
          {Array.isArray(attachment) ? (
            <>
              {attachment.map((val, i) => (
                <> 
                  {fileType.indexOf(val.substr(val.lastIndexOf('.') + 1)) > -1 ?  
                    <a target="_blank" rel="noopener noreferrer" href={attachment}>
                      <img src={Images?.viewIcon} key={i} alt="" className="view-icon icon-align" />
                    </a> : <a target="_blank" rel="noopener noreferrer" href={val}>
                      <img src={val} alt="" key={i} width="400px" />
                    </a>
                  }
                  {/* <a target="_blank" rel="noopener noreferrer" href={val}>
                    <img src={val} alt="" key={i} width="400px" />
                  </a> */}
                  <br></br>
                  <br></br>
                  <br></br>
                </>
              ))}
            </>
          ) : (
            // <img src={attachment} alt="" width="400px" />
            <a target="_blank" rel="noopener noreferrer" href={attachment}>
              <img src={Images?.viewIcon} alt="" className="view-icon" />
            </a>
          )}
        </span>
      </div>
    </div>
  );
};

DocumentView.propTypes = {
  attachment: PropTypes.string,
};

export default DocumentView;
